module.exports = __webpack_public_path__ + "media/scale-b8a5c39c.svg";